<template>
<div class="member-auth-view">
        <div class="auth-scope">
            <div class="auth-scope-title">{{$t("知识库可见范围")}}</div>
            <div class="auth-scope-list" v-for="(item, index) in scopeList" :key="index">
                <div :class="['auth-scope-item',item.disable ? 'auth-scope-item-disabled' : '']" @click="selectAuthScope(item)">
                    <div class="select-icon" :class="{
                            selected: currentScopeIcon(item)
                        }"></div>
                    <div class="auth-scope-item-name">
                        {{ item.desc }}
                    </div>
                </div>
            </div>
        </div>

        <div class="member-setting">
            <div class="member-setting-title">
                <span>{{$t("成员管理")}}</span>
                <div class="member-setting-add" @click="openInviteView">
                    {{ addBtnTitle }}
                </div>
            </div>
            <div class="member-setting-list">
                <a-tabs v-model="currentTab" class="member-tabs" @change="changeTab">
                    <div class="tab-list-pane" v-for="(tabItem, idx) in tabList">
                        <a-tab-pane :key="idx" :title="tabItem">
                            <div class="member-list" ref="MemberListRef">
                                <div v-if="idx === 1 && memberList.length === 0" class="no-member-list">
                                    <img src="@/assets/img/setting/icon_setting_no_member.svg"/>
                                    <span>{{$t("暂无成员")}}</span>
                                </div>
                                <div v-else class="member-list-item" v-for="(item, index) in idx === 0
                                        ? adminList
                                        : memberList">
                                    <div class="worker-avatar">
                                        <div v-if="
                                                (item.toType === 'PERSON' ||
                                                    item.toType === 'APP') &&
                                                    fileAvatar(item) === ''
                                            " class="user-avatar" :style="
                                                avatarColorStye(item.toName)
                                            ">
                                            <div class="user-name">
                                                {{ userName(item.toName) }}
                                            </div>
                                        </div>
                                        <img v-else :src="fileAvatar(item)"/>
                                    </div>
                                    <div class="worker-info">
                                        <div class="worker-name">
                                            {{ item.toName }}
                                        </div>
                                        <div v-if="
                                                userInfo.spaceId !==
                                                    item.toSpace &&
                                                    item.toType !== 'APP'
                                            " class="worker-space-name">
                                            @{{ item.toSpaceName }}
                                        </div>
                                        <div class="worker-tag" v-if="idx === 0 && index === 0">{{$t("所有者")}}                                        </div>
                                        <div class="worker-tag worker-tag-app" v-if="item.toType === 'APP'">{{$t("应用")}}                                        </div>
                                        <div v-if="!!item.inherit" class="worker-recover">{{$t("继承于父级文件")}}                                        </div>
                                    </div>
                                    <div class="worker-auth-diseditable" v-if="idx === 0 && index === 0 && adminList[index].to !== userId">
                                        {{ authName(item.auth) }}
                                    </div>
                                    <a-dropdown v-else-if="idx === 0 && index === 0 && adminList[index].to === userId" class="setting-auth-editable" trigger="click" position="br" @select="
                                            cmd => handlerChangeOwner(cmd, index)
                                        " @popup-visible-change="(v: boolean) => dropdownMenuVisibleChange(v, index)">
                                        <div class="worker-auth-editable" @click="openAuthList(item, index)" @mouseover="
                                                mouseAction(index, true)
                                            " @mouseleave="
                                                mouseAction(index, false)
                                            ">
                                            {{ authName(item.auth) }}
                                            <img :src="changeEditableIcon(index)"/>
                                        </div>
                                        <template #content>
                                            <div class="auth-list" v-for="(auth, i) in adminOwnerAuthList" :key="i">
                                                <a-doption :value="i" :divided="
                                                        [
                                                            'ALL',
                                                            'TRANSFER',
                                                        ].includes(auth.id)
                                                    " :disabled="
                                                        item.edit === false
                                                    ">
                                                    <div class="auth-name" :style="
                                                            auth.id ===
                                                            item.auth
                                                                ? 'color: #5C70FF !important'
                                                                : [
                                                                      'DELETE',
                                                                      'RECOVER'
                                                                  ].includes(
                                                                      auth.id
                                                                  )
                                                                ? 'color: #FF4747 !important; margin-left: 36px'
                                                                : 'color: #222329 !important; margin-left: 36px'
                                                        ">
                                                        <img v-show="
                                                                auth.id ===
                                                                    item.auth
                                                            " src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                                    </div>
                                                    <div class="auth-desc">
                                                        {{ auth.desc }}
                                                    </div>
                                                </a-doption>
                                            </div>
                                            <div v-if="currentTab !== 0" class="push-message">
                                                <span :style="
                                                        memberList[index]
                                                            .pushMessage
                                                            ? 'color: #222329;'
                                                            : 'color: #DDDFE6;'
                                                    ">{{$t("修改时发送通知")}}</span>
                                                <a-switch class="auth-push-switch" v-model="
                                                        memberList[index]
                                                            .pushMessage
                                                    " checked-color="#5C70FF" unchecked-color="#DDDFE6"></a-switch>
                                            </div>
                                        </template>
                                    </a-dropdown>
                                    <a-dropdown v-else class="setting-auth-editable" trigger="click" position="br" @select="
                                            cmd => handlerChangeAuth(cmd, index)
                                        " @popup-visible-change="(v: boolean) => dropdownMenuVisibleChange(v, index)">
                                        <div class="worker-auth-editable" @click="openAuthList(item, index)" @mouseover="
                                                mouseAction(index, true)
                                            " @mouseleave="
                                                mouseAction(index, false)
                                            ">
                                            {{ authName(item.auth) }}
                                            <img :src="changeEditableIcon(index)"/>
                                        </div>
                                        <template #content>
                                            <div class="auth-list" v-for="(auth, i) in idx === 0
                                                    ? adminAuthList
                                                    : memberAuthList" :key="i">
                                                <a-doption :value="i" :divided="
                                                        [
                                                            'ALL',
                                                            'RECOVER',
                                                            'DELETE'
                                                        ].includes(auth.id)
                                                    " :disabled="
                                                        item.edit === false
                                                    ">
                                                    <div class="auth-name" :style="
                                                            auth.id ===
                                                            item.auth
                                                                ? 'color: #5C70FF !important'
                                                                : [
                                                                      'DELETE',
                                                                      'RECOVER'
                                                                  ].includes(
                                                                      auth.id
                                                                  )
                                                                ? 'color: #FF4747 !important; margin-left: 36px'
                                                                : 'color: #222329 !important; margin-left: 36px'
                                                        ">
                                                        <img v-show="
                                                                auth.id ===
                                                                    item.auth
                                                            " src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                                    </div>
                                                    <div class="auth-desc">
                                                        {{ auth.desc }}
                                                    </div>
                                                </a-doption>
                                            </div>
                                            <div v-if="currentTab !== 0" class="push-message">
                                                <span :style="
                                                        memberList[index]
                                                            .pushMessage
                                                            ? 'color: #222329;'
                                                            : 'color: #DDDFE6;'
                                                    ">{{$t("修改时发送通知")}}</span>
                                                <a-switch class="auth-push-switch" v-model="
                                                        memberList[index]
                                                            .pushMessage
                                                    " checked-color="#5C70FF" unchecked-color="#DDDFE6"></a-switch>
                                            </div>
                                        </template>
                                    </a-dropdown>
                                    <a-modal class="file-share-common-dialog" v-model:visible="showPushMsgDialog" :simple="true" :footer="false" :render-to-body="false">
                                        <div class="content">
                                            <div class="title">
                                                <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("提示")}}                                            </div>
                                            <div class="desc">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。")}}                                            </div>
                                            <div class="bottom">
                                                <div class="cancel-btn" @click.stop="
                                                        showPushMsgDialog = memberList[
                                                            index
                                                        ].pushMessage = false
                                                    ">{{$t("取消")}}                                                </div>
                                                <div class="confirm-btn" @click.stop="
                                                        modifyAuth(
                                                            currentCmd,
                                                            currentIndex
                                                        )
                                                    ">{{$t("确认发送")}}                                                </div>
                                            </div>
                                        </div>
                                    </a-modal>
                                </div>
                            </div>
                        </a-tab-pane>
                    </div>
                </a-tabs>
            </div>
        </div>
        <div v-if="isShowInviteView" id="invite-view-container"></div>
        <a-modal class="add-memeber-dialog" body-class="add-memeber-manage" v-model:visible="showAddMemberDialog" :simple="true" :footer="false" :unmount-on-close="true" :mask-closable="false">
            <AddMemberView :current-tab="currentTab" :addData="shouldAddMemberList" :spaceId="userInfo.spaceId" @closeAddMemberView="showAddMemberDialog = false" @addConfirm="addMembersConfirm"></AddMemberView>
        </a-modal>
        <a-modal class="file-transfer-dialog" v-model:visible="showTransferDialog" :simple="true" :footer="false" :mask-closable="false" :esc-to-close="false" :unmount-on-close="true">
                <TransferView v-if="showTransferDialog" :transferType="'wiki'" @closeTransferDialog="closeTransferDialog" @transferWikiOwner="gotoTransferWikiOwner"></TransferView>
            </a-modal>
    </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'vuex';
import { reactive } from 'vue';

import { SPACE_SCOPE_LIST } from '../../constants/SettingSpace';
import { ADMIN_AUTH_LIST, MEMBER_AUTH_LIST, ADMIN_OWNER_AUTH_LIST } from '../../constants/SettingAuth';
import nameColor from '../../utils/nameColor';
import memberAvatar from '../../utils/avatar';
import AddMemberView from './addMember.vue';
import TransferView from '../transfer/TransferView.vue';
import { transferWikiOwner } from '../../core/api/setting';

import {
getWikiSpaceInfo,
modifyWikiSpaceInfo,
getWikiSpaceMemberList,
addWikiSpaceMember,
deletWikiSpaceMember } from
'../../core/api/setting';

import ICON_SETTING_SELECTED from '@/assets/img/setting/icon_setting_selected.svg';
import ICON_SETTING_UNSELECTED from '@/assets/img/setting/icon_setting_unselected.svg';
import EditableSelectedIcon from '@/assets/img/share/icon_file_auth_editable_selected.png';
import EditableHoverIcon from '@/assets/img/share/icon_file_auth_editable_hover.png';
import EditableIcon from '@/assets/img/share/icon_file_auth_editable.png';
import DepartmentAvatar from '@/assets/img/share/icon_file_file.png';
import { useI18n, intl } from 'tci18n-vue3';
import { store } from '../../store/store';
import GroupAvatar from '@/assets/img/share/fp_user_group.png';
import UnitedDepartmentAvatar from '@/assets/img/share/finder_dept_sub_united.png';

export default {
  name: 'MemberAuthView',
  components: {
    AddMemberView,
    TransferView },

  data() {
    return {
      scopeList: SPACE_SCOPE_LIST,
      currentScope: '',
      tabList: [intl.$t("管理员"), intl.$t("成员")],
      currentSpaceInfo: null,
      currentWikiSpaceInfo: null,
      currentTab: 0,
      adminList: reactive([]),
      memberList: reactive([]),
      editableHover: reactive([]),
      editableFocus: reactive([]),
      showTransferDialog: false,
      adminOwnerAuthList: reactive(ADMIN_OWNER_AUTH_LIST),
      adminAuthList: reactive(ADMIN_AUTH_LIST),
      memberAuthList: reactive(MEMBER_AUTH_LIST),
      inviteUsersList: [],
      selectDepartList: [],
      disableUserList: [],
      selectGrouptList: [],
      selectDepartsDisabled: [],
      deletedList: [],
      isShowInviteView: false,
      showAddMemberDialog: false,
      shouldAddMemberList: reactive([]),
      showPushMsgDialog: false,
      currentCmd: null,
      currentIndex: null,
      selectImList: [] };

  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo,
      userId: (state) => state.userModule.userId,
      spaceId: (state) => state.userModule.spaceId,
      wikiI18n: (state) => state.kbModule.wikiI18n }),

    userInfo() {
      return { userId: this.userId, spaceId: this.spaceId };
    },
    inviteViewTitle() {
      return this.currentTab === 0 ? intl.$t("添加管理员") : intl.$t("添加成员");
    },
    currentWikiSpaceId() {
      return this.wikiSpaceInfo.wikiSpaceId;
    },
    addBtnTitle() {
      const { lang } = useI18n();
      if (lang === 'zh-cn') {
        return intl.$t("添加") + (this.currentTab === 0 ? intl.$t("管理员") : intl.$t("成员"));
      } else {
        return 'Add';
      }
    } },

  methods: {
    ...mapActions({
      setWikiSpaceInfo: 'kbTreeNodeModule/setWikiSpaceInfo' }),

    closeTransferDialog() {
      this.showTransferDialog = false;
    },
    gotoTransferWikiOwner(transferMemberUniqueId: string) {
      transferWikiOwner(this.currentWikiSpaceId, transferMemberUniqueId).
      then((response: any) => {
        const res = response.data;
        if (res.code === 200) {
          this.showTransferDialog = false;
          this.$message.success(intl.$t("转移所有权成功"));
          window.location.reload();
        } else {
          this.$message.error(intl.$t(`转移所有权失败，请重新尝试`));
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("转移所有权失败，请重新尝试"));
      });
    },
    currentScopeIcon(item: any) {
      return this.currentScope === item.name;
    },
    selectAuthScope(item: any) {
      if (this.currentScope === item.name) return;
      // 443：打开组织内所有人及知识库成员可见选项
      // if (
      //     this.currentScope === item.name ||
      //     item.name === 'ORGANIZATION'
      // ) {
      //     return;
      // }

      modifyWikiSpaceInfo(
      this.currentWikiSpaceId,
      this.currentSpaceInfo.wikiSpaceName,
      this.currentSpaceInfo.wikiSpaceDesc,
      item.name).

      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.currentScope = item.name;
          this.$message.success(intl.$t("修改知识库可见范围成功"));
          if (this.currentTab === 1) {
            this.queryWikiSpaceMemberList();
          }
          this.currentSpaceInfo.visibleScope = this.currentScope;
          this.setWikiSpaceInfo(this.currentSpaceInfo);
        } else {
          this.$message.error(intl.$t(`修改知识库可见范围失败，{message}`, { message: message }));


        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("获取知识库可见范围失败，请刷新重试"));
      });
    },
    authName(auth: string) {
      switch (auth) {
        case 'ALL':
          return intl.$t("所有权限");
        case 'READ':
          return intl.$t("仅查看");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载");
        case 'WRITE':
          return intl.$t("编辑");}

    },
    fileAvatar(item: any) {
      if (item.toType === 'PERSON' || item.toType === 'APP') {
        const userAvatar = memberAvatar.getMemberAvatar(
        item.toAvatar,
        '');

        return (
          userAvatar['100'] ??
          userAvatar['300'] ??
          userAvatar['original']);

      } else if (item.toType === 'GROUP') {
        if (item.toAvatar && item.toAvatar.length > 0) {
          return item.toAvatar;
        }
        return GroupAvatar;
      } else if (item.toType === 'USER_GROUP') {
        return GroupAvatar;
      } else if (
      item.toType === 'DEPARTMENT' &&
      item.toSpace !== this.spaceId)
      {
        return UnitedDepartmentAvatar;
      } else {
        return DepartmentAvatar;
      }
    },
    avatarColorStye(name: string) {
      let avatarColor = nameColor.getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name: string) {
      return nameColor.getLastName(name);
    },
    handlerChangeOwner(command: any, index: number) {
      if (this.adminOwnerAuthList[command].id === 'TRANSFER') {
        this.showTransferDialog = true;
      }
    },
    handlerChangeAuth(command: any, index: number) {
      if (this.currentTab === 0) {
        if (this.adminAuthList[command].id === 'DELETE') {
          const wikiSpaceMemberId = this.adminList[index].
          wikiSpaceMemberId;
          const wikiSpaceUserId = this.adminList[index].to;
          this.deletedWikiSpaceMember(
          wikiSpaceMemberId,
          () => {
            this.$message.success(intl.$t("移除成功"));
            if (wikiSpaceUserId === this.userId) {
              // 自己是管理员，自己删除了自己，reload页面，因为没权限进入设置了
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              this.queryWikiSpaceMemberList();
            }
          },
          (message?: string) => {
            this.$message.error(intl.$t(`移除失败！{message}`, { message: message }));
          });

        }
      } else {
        if (this.memberAuthList[command].id === 'DELETE') {
          /// 删除协作者
          const wikiSpaceMemberId = this.memberList[index].
          wikiSpaceMemberId;
          this.deletedWikiSpaceMember(
          wikiSpaceMemberId,
          () => {
            this.$message.success(intl.$t("移除成功"));
            this.queryWikiSpaceMemberList();
          },
          (message?: string) => {
            this.$message.error(intl.$t(`移除失败！{message}`, { message: message }));
          });

        } else {
          if (this.memberList[index].toType !== 'PERSON') {
            if (this.memberList[index].pushMessage) {
              this.currentCmd = command;
              this.currentIndex = index;
              this.showPushMsgDialog = true;
            } else {
              this.modifyAuth(command, index);
            }
          } else {
            this.modifyAuth(command, index);
          }
        }
      }
    },
    modifyAuth(command: number, index: number) {
      this.showPushMsgDialog = false;
      /// 修改权限
      const list = [
      {
        auth: this.memberAuthList[command].id,
        to: this.memberList[index].to,
        toSpace: this.memberList[index].toSpace,
        toType: this.memberList[index].toType,
        memberIdentity: 'MEMBER' }];


      const pushMessage = this.memberList[index].pushMessage;
      this.addedWikiSpaceMember(
      this.currentWikiSpaceId,
      list,
      pushMessage,
      () => {
        this.memberList[index].auth = this.memberAuthList[
        command].
        id;
        this.queryWikiSpaceMemberList();
        this.$message.success(intl.$t("修改成功"));
      },
      (message?: string) => {
        this.$message.error(intl.$t(`修改失败，{message}`, { message: message }));
      });

    },
    openAuthList(item: any, index: number) {
      this.editableFocus[index] = !this.editableFocus[index];
      if (!this.editableFocus[index]) {
        return;
      }
      if (this.currentTab === 0) {
      } else {
        if (item.toType === 'TOP_DEPARTMENT') {
          if (
          this.memberAuthList.some(
          (item: any) => item.id === 'DELETE'))

          {
            this.memberAuthList = this.memberAuthList.filter(
            (i: any) => i.id !== 'DELETE');

          }
        } else {
          if (
          !this.memberAuthList.some(
          (item: any) => item.id === 'DELETE'))

          {
            this.memberAuthList.push({
              id: 'DELETE',
              name: intl.$t("删除成员") });

          }
        }
        this.memberList[index].pushMessage = false;
        // if (item.toType === 'PERSON') {
        //     this.memberList[index].pushMessage = true;
        // } else {
        //     this.memberList[index].pushMessage = false;
        // }
      }
    },
    dropdownMenuVisibleChange(visible: boolean, index: number) {
      if (!visible) {
        // this.$refs.MemberListRef.style.overflowY = 'auto';
        this.editableFocus[index] = visible;
        this.editableHover[index] = visible;
      } else {
        // this.$refs.MemberListRef.style.overflowY = 'hidden';
      }
    },
    mouseAction(index: number, isHover: boolean) {
      if (this.editableFocus[index] === true && !isHover) {
        this.editableHover[index] = true;
        return;
      }
      this.editableHover[index] = isHover;
    },
    changeEditableIcon(index: number) {
      return this.editableFocus[index] ?
      EditableSelectedIcon :
      this.editableHover[index] ?
      EditableHoverIcon :
      EditableIcon;
    },
    changeTab(index: number) {
      this.currentTab = index;
      this.changeEditableIconList(this.currentTab);
      this.queryWikiSpaceMemberList();
    },

    openInviteView() {
      this.disableUserList = [];
      this.selectDepartList = [];
      this.inviteUsersList = [];
      this.selectDepartsDisabled = [];
      this.selectGrouptList = [];
      this.selectImList = [];
      if (this.currentTab === 0) {
        for (let i = 0; i < this.adminList.length; i++) {
          if (i === 0) {
            this.disableUserList.push({
              userId: this.adminList[0].to,
              type: 0,
              spaceId: this.adminList[0].toSpace,
              memberName: this.adminList[0].toName,
              memberAvatar: this.adminList[0].toAvatar,
              spaceName: this.adminList[0].toSpaceName });

          } else {
            this.inviteUsersList.push({
              userId: this.adminList[i].to,
              type: 0,
              spaceId: this.adminList[i].toSpace,
              memberName: this.adminList[i].toName,
              memberAvatar: this.adminList[i].toAvatar,
              spaceName: this.adminList[i].toSpaceName });

          }
        }
      } else {
        this.adminList.forEach((item: any) => {
          this.disableUserList.push({
            userId: item.to,
            type: 0,
            spaceId: item.toSpace,
            memberName: item.toName,
            memberAvatar: item.toAvatar,
            spaceName: item.toSpaceName });

        });
        this.memberList.forEach((item: any) => {
          if (item.toType === 'DEPARTMENT') {
            this.selectDepartList.push({
              departmentId: item.to,
              type: 1,
              spaceId: item.toSpace,
              departmentName: item.toName,
              spaceName: item.toSpaceName });

          }
          if (item.toType === 'PERSON') {
            this.inviteUsersList.push({
              userId: item.to,
              type: 0,
              spaceId: item.toSpace,
              memberName: item.toName,
              memberAvatar: item.toAvatar,
              spaceName: item.toSpaceName });

          }
          if (item.toType === 'TOP_DEPARTMENT') {
            // this.selectDepartsDisabled.push({
            //     departmentId: item.to,
            //     type: 1,
            //     spaceId: item.toSpace,
            //     departmentName: item.toName,
            //     spaceName: item.toSpaceName
            // });
          }
          if (item.toType === 'USER_GROUP') {
            this.selectGrouptList.push({
              type: 2,
              name: item.toName,
              description: item.toName,
              ...item,
              id: item.to });

          }

          if (item.toType === 'GROUP') {
            this.selectImList.push({
              type: 3,
              avatar: item.toAvatar,
              chatAvatar: item.toAvatar,
              chatName: item.toName,
              name: item.toName,
              ...item,
              id: item.to });

          }
        });
      }

      this.isShowInviteView = true;

      setTimeout(async () => {
        await import('@toca/toca-finder/dist/style.css');
        const { TocaFinder } = await import('@toca/toca-finder');

        const params = {
          locale: this.wikiI18n,
          envConfig: import.meta.env.MODE,
          selectTitle: this.inviteViewTitle,
          confirmTitle: intl.$t("下一步"),
          maxNum: 9999,
          maxNumNotiy: intl.$t("协作者人数已达上限"),
          showUserGroup: this.currentTab === 1,
          selectGroupList: this.selectGrouptList,
          confirmEmpty: false,
          isShowUnitedSpaces: true,
          selectUserList: this.inviteUsersList,
          selectUsersDisabled: this.disableUserList,
          selectDepartsDisabled: this.selectDepartsDisabled,
          selectDepartList: this.selectDepartList,
          closeOnClickModal: false,
          allowCheckDepart: this.currentTab === 0 ? false : true,
          show: this.isShowInviteView,
          modal: true,
          checkStrictly: true,
          showIMGroup: this.currentTab === 0 ? false : true,
          selectImList: this.selectImList,
          userId: store.state.userModule.userId,
          spaceId: store.state.userModule.spaceId,
          token: store.state.userModule.token,
          deviceId: store.state.userModule.deviceId,
          memberId: store.state.userModule.userDetail?.id,
          handerConfirmCallback: this.inviteConfirm,
          handerCloseCallback: this.closeInviteView };

        this.tocaFinder = new TocaFinder(
        '#invite-view-container',
        params);

      }, 0);
    },
    async inviteConfirm(addData: any[], allData: any[], reduceData: any[]) {
      if (addData.length === 0 && reduceData.length === 0) {
        this.isShowInviteView = false;
        return;
      }
      if (reduceData.length > 0) {
        for (const {
          type,
          userId,
          departmentId,
          id,
          spaceId } of
        reduceData) {
          let to = '';
          switch (type) {
            case 0:
              to = userId;
              break;
            case 1:
              to = departmentId;
              break;
            case 2:
              to = id;
              break;
            case 3:
              to = id;
              break;}

          const member =
          this.currentTab === 0 ?
          this.adminList.find((item: any) => {
            if (type !== 2) {
              return (
                item.to === to &&
                item.toSpace === spaceId);

            } else {
              return item.to === to;
            }
          }) :
          this.memberList.find((item: any) => {
            if (type !== 2 && type !== 3) {
              return (
                item.to === to &&
                item.toSpace === spaceId);

            } else {
              return item.to === to;
            }
          });
          if (member == null) continue;
          this.deletedWikiSpaceMember(
          member.wikiSpaceMemberId,
          () => {
            this.queryWikiSpaceMemberList();
          },
          (message?: string) => {
            this.$message.error(intl.$t(`移除失败！{message}`, { message: message }));
          });

        }
      }

      if (addData.length > 0) {
        this.shouldAddMemberList.length = 0;
        if (this.currentTab === 0) {
          addData.forEach((item: any) => {
            this.shouldAddMemberList.push({
              toSpace: item.spaceId,
              toType: 'PERSON',
              to: item.userId,
              auth: 'ALL',
              memberIdentity: 'ADMIN',
              toName: item.memberName,
              toAvatar: item.memberAvatar,
              spaceName: item.spaceName });

          });
        } else {
          addData.forEach((item: any) => {
            let to = '';
            let toType = '';
            let toName = '';
            switch (item.type) {
              case 0:
                to = item.userId;
                toType = 'PERSON';
                toName = item.memberName;
                break;
              case 1:
                to = item.departmentId;
                toType = 'DEPARTMENT';
                toName = item.departmentName;
                break;
              case 2:
                to = item.id;
                toType = 'USER_GROUP';
                toName = item.name;
                break;
              case 3:
                to = item.id;
                toType = 'GROUP';
                toName = item.name;
                break;}

            this.shouldAddMemberList.push({
              to: to,
              toSpace: item.spaceId ?? this.userInfo.spaceId,
              toType: toType,
              auth: 'READ_DOWNLOAD',
              memberIdentity: 'MEMBER',
              toName: toName,
              toAvatar: this.transAvatar(item),
              spaceName: item.spaceName });

          });
        }
        this.showAddMemberDialog = true;
      }
    },
    transAvatar(item: any) {
      // 0:用户 1:部门 2：用户组  3： IM群组
      if (item.type === 0) {
        return item.memberAvatar;
      } else if (item.type === 2) {
        return GroupAvatar;
      } else if (item.type === 3) {
        return item.avatar;
      } else if (item.type === 1 && item.spaceId !== this.spaceId) {
        return UnitedDepartmentAvatar;
      } else {
        return DepartmentAvatar;
      }
    },
    addMembersConfirm(shouldAddData: Array<any>, pushMessage: boolean) {
      this.addedWikiSpaceMember(
      this.currentWikiSpaceId,
      shouldAddData,
      pushMessage,
      () => {
        this.showAddMemberDialog = false;
        this.queryWikiSpaceMemberList();
        this.$message.success(intl.$t("添加成功"));
      },
      (message?: string) => {
        const errorTip: string =
        this.currentTab === 0 ? intl.$t("管理员") : intl.$t("成员");
        this.$message.error(intl.$t(`添加{errorTip}失败，{message}`, { errorTip: errorTip, message: message }));
      });

    },
    closeInviteView() {
      this.isShowInviteView = false;
    },
    getCurrentSpaceInfo() {
      getWikiSpaceInfo(this.currentWikiSpaceId).
      then((res: any) => {
        const { code, message, data } = res.data;
        if (code === 200) {
          this.currentSpaceInfo = data;
          this.currentScope = data.visibleScope;
          this.changeTab(this.currentTab);
        } else {
          this.$message.error(message);
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("获取空间信息失败，请刷新重试"));
      });
    },
    queryWikiSpaceMemberList() {
      getWikiSpaceMemberList(
      this.currentWikiSpaceId,
      this.currentTab === 0 ? 'ADMIN' : 'MEMBER').

      then((res: any) => {
        const { code, message, data } = res.data;
        if (code === 200) {
          if (this.currentTab === 0) {
            this.adminList = data;
          } else {
            let originalList = data;
            this.memberList = originalList.map((item: any) =>
            item.toType === 'PERSON' ?
            { ...item, pushMessage: true } :
            { ...item, pushMessage: false });

          }
        } else {
          this.$message.error(message);
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("获取列表数据失败，请刷新重试"));
      });
    },
    addedWikiSpaceMember(
    wikiSpaceMemberId: string,
    addList: any[],
    pushMessage: true,
    onSuccess: () => void,
    onFailed: (message?: any) => void)
    {
      addWikiSpaceMember(wikiSpaceMemberId, pushMessage, addList).
      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          onSuccess();
        } else {
          onFailed(message);
        }
      }).
      catch((err) => {
        onFailed(intl.$t("请重新操作"));
      });
    },
    deletedWikiSpaceMember(
    wikiSpaceMemberId: string,
    onSuccess: () => void,
    onFailed: (message?: any) => void)
    {
      deletWikiSpaceMember(wikiSpaceMemberId).
      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          onSuccess();
        } else {
          onFailed(message);
        }
      }).
      catch((err) => {
        onFailed();
      });
    },
    initData() {
      this.getCurrentSpaceInfo();
    },
    changeEditableIconList(tabIndex: number) {
      this.editableHover.splice(0, this.editableHover.length);
      this.editableFocus.splice(0, this.editableFocus.length);
      for (
      let i = 0;
      i < (
      tabIndex === 0 ?
      this.adminList.length :
      this.memberList.length);
      i++)
      {
        this.editableHover.push(false);
        this.editableFocus.push(false);
      }
    } },

  created() {
    this.initData();
  },
  mounted() {} };
</script>

<style lang="scss" scoped>
.member-auth-view {
    height: calc(100% - 94px);

    .auth-scope {
        margin: 40px 24px;
        height: 92px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex-wrap: nowrap;

        .auth-scope-title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
        }

        .auth-scope-list {

            .auth-scope-item-disabled {
                pointer-events: none;
                opacity: 0.5;
                cursor: not-allowed;
            }

            .auth-scope-item {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-top: 16px;
                cursor: pointer;

                .select-icon {
                    width: 16px;
                    height: 16px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    background-image: url(@/assets/img/setting/icon_setting_unselected.svg);

                    &:hover {
                        background-image: url(@/assets/img/setting/icon_setting_selected_hover.svg);
                    }

                    &.selected {
                        background-image: url(@/assets/img/setting/icon_setting_selected.svg);
                    }

                    &.disabled {
                        cursor: not-allowed;
                        pointer-events: none;
                    }
                }

                .auth-scope-item-name {
                    margin-left: 8px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    line-height: 6px;
                    user-select: none;

                    &.disabled {
                        color: #ccced7;
                    }
                }
            }
        }
    }

    .member-setting {
        margin: 0px 24px 24px 24px;
        width: inherit;
        height: calc(100% - 132px);

        .member-setting-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 14px;
                color: #121317;
                line-height: 20px;
            }

            .member-setting-add {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 6px;
                height: 26px;
                background: #5c70ff;
                border-radius: 6px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 17px;
                cursor: pointer;
            }
        }

        .member-setting-list {
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            background: #ffffff;
            border: 1px solid #e8e9ee;
            border-radius: 4px;
            padding: 24px;
            height: calc(100% - 104px);

            .tab-list-pane {
                max-height: 100%;
                width: 100%;

                .member-list {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    overflow-y: auto;
                    overflow-x: hidden;

                    .no-member-list {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                        margin-top: 88px;

                        img {
                            width: 106px;
                            height: 106px;
                            object-fit: contain;
                        }

                        span {
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            font-size: 14px;
                            color: #a2a4b0;
                            line-height: 20px;
                            margin-top: 16px;
                        }
                    }

                    .member-list-item {
                        width: 100%;
                        height: 52px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                        flex-shrink: 0;
                        cursor: pointer;

                        &:hover {
                            background-color: #f4f6f9;
                            border-radius: 8px;
                        }

                        .worker-avatar {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 32px;
                            height: 32px;
                            border-radius: 8px;
                            margin-right: 8px;

                            img {
                                width: 32px;
                                height: 32px;
                                border-radius: 8px;
                            }

                            .user-avatar {
                                width: 32px;
                                height: 32px;
                                border-radius: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .user-name {
                                    font-weight: 600;
                                    font-size: 12px;
                                    color: #ffffff;
                                    letter-spacing: 0;
                                    line-height: 17px;
                                }
                            }
                        }

                        .worker-info {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: flex-start;
                            flex: 1;
                            height: 100%;
                            margin-right: 12px;

                            .worker-name {
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                font-size: 14px;
                                color: #222329;
                                letter-spacing: 0;
                                line-height: 20px;
                            }

                            .worker-space-name {
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                font-size: 14px;
                                color: #fc7d29;
                                letter-spacing: 0;
                                line-height: 20px;
                                margin-left: 4px;
                            }

                            .worker-tag-app {
                                background-color: #fff1ee !important;
                                color: #f05f11 !important;
                            }

                            .worker-tag {
                                height: 18px;
                                padding: 0 4px;
                                margin-left: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 4px;
                                background-color: #eef0ff;
                                font-family: PingFangSC-Medium;
                                font-weight: 500;
                                font-size: 10px;
                                color: #5c70ff;
                                letter-spacing: 0;
                                line-height: 8px;
                            }

                            .worker-recover {
                                font-size: 12px;
                                color: #fba724;
                                margin-left: 8px;
                            }
                        }

                        .worker-auth-diseditable {
                            font-family: PingFangSC-Regular;
                            font-weight: 300;
                            font-size: 14px;
                            color: #222329;
                            letter-spacing: 0;
                            line-height: 20px;
                        }

                        .worker-auth-editable {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            height: 32px;
                            font-family: PingFangSC-Regular;
                            font-weight: 300;
                            font-size: 14px;
                            color: #222329;
                            letter-spacing: 0;
                            text-align: center;
                            line-height: 20px;
                            border: none;
                            background-color: transparent;
                            cursor: pointer;

                            &:hover {
                                color: #5c70ff;
                            }

                            img {
                                margin-left: 4px;
                                width: 10px;
                                height: 10px;
                                object-fit: contain;
                            }

                            .editable-icon {
                                margin-left: 4px;
                                width: 10px;
                                height: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
@import './theme/addMemeberDialog.scss';

.member-tabs {
    width: 100%;
    height: 100%;

    .arco-tabs-content {
        width: 100%;
        height: calc(100% - 46px);
        overflow-y: auto;
        overflow-x: hidden;

        .arco-tabs-content-list {
            flex-direction: column;
            margin-left: 0 !important;
            height: 100%;
        }
    }

    .arco-tabs-nav-tab {
        height: 29px;
        border-bottom: 1px solid #e8e9ee;

        .arco-tabs-tab {
            padding: 0;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #a2a4b0;
            letter-spacing: 0;
            cursor: pointer;
            margin: 0 32px 0 0;

            &:hover {
                color: #5c70ff;
            }

            .arco-tabs-tab-title {
                padding: 0;

                &::before {
                    display: none;
                }
            }
        }

        .arco-tabs-tab-active {
            padding: 0;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            letter-spacing: 0;
            cursor: pointer;

            &:hover {
                color: #121317;
            }
        }

        .arco-tabs-nav-ink {
            background-color: #5d71ff;
            border-radius: 1px;
        }
    }
}

.setting-auth-editable {
    z-index: 3001 !important;

    .arco-dropdown {
        padding: 0 !important;
        background: #ffffff !important;
        border: 1px solid #e6e8ec !important;
        box-shadow: 0 8px 12px 0 #1213171a !important;
        border-radius: 8px !important;
        width: 258px !important;

        .arco-dropdown-list-wrapper {
            max-height: none !important;

            .arco-dropdown-option {
                min-height: 28px !important;
                padding: 0 0 !important;
                margin: 4px 4px 4px 4px !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                justify-content: center !important;
                line-height: 100% !important;
                width: inherit !important;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9 !important;
                    border-radius: 8px !important;
                }

                .arco-dropdown-option-content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .auth-name {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                        font-family: PingFangSC-Regular !important;
                        color: #222329 !important;
                        line-height: 20px;
                        margin-top: 4px;

                        img {
                            width: 15px;
                            height: 11px;
                            margin: 0 11px;
                        }
                    }

                    .auth-desc {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #a5a7b3;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin: 0 16px 4px 36px;
                        white-space: pre-wrap !important;
                        word-wrap: break-word;
                    }
                }
            }

            .push-message {
                height: 28px;
                padding: 4px 16px 0 36px;
                margin: 4px;
                border-top: 1px solid #f1f4f5;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                span {
                    flex: 1;
                    font-size: 14px;
                    font-weight: 300;
                    font-family: PingFangSC-Regular;
                    line-height: 20px;
                    transition: color 0.2s ease-in-out;
                }
            }
        }

        .arco-scrollbar-track {
            display: none;
        }
    }
}
</style>
